/* eslint-disable max-lines */

import { BREACHES_TYPES } from '@/lib/constants/easm/breaches'

export const EASM_DASHBOARD = {
  TITLE: 'Panel EASM',
  SUBTITLE: 'Gestión de la superficie de ataque externa',
  SUMMARY: {
    PUBLIC_DOMAINS: 'Dominios Públicos',
    DOMAINS: 'Dominios',
    SUBDOMAIN_SINGULAR: 'subdominio',
    SUBDOMAIN_PLURAL: 'subdominios',
    EXPOSED_IPS: 'IPs expuestas',
    VULNERABILITY_SINGULAR: 'vulnerabilidades',
    BREACH_PLURAL: 'brechas',
    CERTIFICATE_PLURAL: 'certificados',
    EXPOSURE_BREAKDOWN: 'Desglose de Exposición',
    NO_DATA: 'Sin datos',
  },
  SEVERITY_CARD: {
    TITLE: 'Distribución de Vulnerabilidades',
    NO_VULNERABILITIES: 'No se detectaron vulnerabilidades',
  },
  TOP_DOMAINS: {
    TITLE: 'Subdominios de Mayor Riesgo',
    NO_DATA: 'Sin datos disponibles',
    RISK_SCORE: 'Puntuación de Riesgo',
  },
  BREACHES: {
    TITLE: 'Brechas Conocidas',
    TOTAL: 'Total',
    CRITICAL: 'Críticas',
    HIGH: 'Altas',
    MEDIUM: 'Medias',
    LOW: 'Bajas',
    UNKNOWN: 'Desconocidas',
    PASSWORD_EXPOSED: 'Contraseña expuesta',
    NON_CRITICAL: 'no críticas',
    NO_BREACHES: 'No se detectaron brechas',
  },
  CERTIFICATES: {
    TITLE: 'Certificados',
    TOTAL: 'Total',
    VALID: 'Válidos',
    EXPIRED: 'Expirados',
    NO_CERTIFICATES: 'No se encontraron certificados',
  },
  TRENDS: {
    TITLE: 'Tendencia de Vulnerabilidades',
    COMPUTING: 'Calculando tendencias',
    LAST_SCAN: 'Último escaneo',
  },
  DOWNLOAD_REPORT: 'Descargar Informe',
}

export const EASM_PUBLIC_DOMAINS = {
  TITLE: 'Dominios Públicos',
  SEARCH_PLACEHOLDER: 'Buscar subdominios...',
  NO_PUBLIC_DOMAINS_FOUND: 'No se encontraron dominios públicos',
  MONITORING: {
    LABEL: 'Monitoring',
    DOMAIN_SINGULAR: 'dominio',
    DOMAIN_PLURAL: 'dominios',
    SUBDOMAIN_SINGULAR: 'subdominio',
    SUBDOMAIN_PLURAL: 'subdominios',
  },
  PUBLIC_DOMAIN_CARD: {
    SUBDOMAIN: 'Subdominio',
    DOMAIN: 'Dominio',
    IP_ADDRESS: 'Dirección IP',
    IP_ADDRESSES: 'Direcciones IP',
    TECHNOLOGIES: 'Tecnologías',
    PORTS: 'Puertos',
  },
  PORT_STATUS: {
    open: 'Abierto',
    closed: 'Cerrado',
    filtered: 'Filtrado',
  },
}
export const EASM_CERTIFICATES = {
  TITLE: 'Certificados',
  NO_CERTIFICATES_FOUND: 'No se encontraron certificados',
  SEARCH_PLACEHOLDER: 'Buscar certificados...',
  COLUMNS: {
    STATUS: 'Estado',
    NAME: 'Nombre',
    DOMAIN: 'Dominio',
    ALGORITHM: 'Algoritmo',
    KEY_SIZE: 'Tamaño de clave',
    SIGNATURE: 'Firma',
  },
  MONITORING: {
    LABEL: 'Monitoring',
    CERTIFICATE_SINGULAR: 'certificado',
    CERTIFICATE_PLURAL: 'certificados',
    DOMAIN_SINGULAR: 'dominio',
    DOMAIN_PLURAL: 'dominios',
    VALID_SINGULAR: 'válido',
    VALID_PLURAL: 'válidos',
    EXPIRED_SINGULAR: 'expirado',
    EXPIRED_PLURAL: 'expirados',
  },
  CERTIFICATE_CARD: {
    DOMAINS: 'Dominios Asignados',
    STATUS: 'Estado',
    ALGORITHM: 'Algoritmo:',
    KEY_SIZE: 'Tamaño de clave:',
    SIGNATURE_ALGORITHM: 'Firma:',
    DETAILS: 'Detalles del Certificado',
    ENDPOINTS: 'Endpoints',
    ENDPOINT_IP: 'IP',
    ENDPOINT_HOSTNAME: 'Subdominio',
    ENDPOINT_PORT: 'Puerto',
    SAN: 'Nombres Alternativos del Sujeto',
    ISSUER: 'Emisor:',
    VALID_FROM: 'Válido desde:',
    VALID_TO: 'Válido hasta:',
    TECHNICAL_DETAILS: 'Detalles Técnicos',
    SERIAL_NUMBER: 'Número de Serie',
    SHA1_FINGERPRINT: 'Huella SHA1',
    SHA256_FINGERPRINT: 'Huella SHA256',
  },
  CERTIFICATE_STATUS: {
    valid: 'Válido',
    expired: 'Expirado',
  },
}

export const EASM_VULNERABILITIES = {
  DESCRIPTION: 'Descripción',
  TITLE: 'Vulnerabilidades Externas',
  OCCURRENCES: 'Ocurrencias',
  AFFECTED_ASSETS: 'Hosts Afectados',
  DETAILS: 'Detalles',
  REMEDIATION: 'Remediación',
  CVSS_SCORE: 'Puntuación CVSS',
  CVE_ID: 'CVE',
  PORT: 'Puerto',
  TOTAL_VULNERABILITIES: 'Total',
  CRITICALITY: {
    critical: 'Crítico',
    high: 'Alto',
    medium: 'Medio',
    low: 'Bajo',
  },
  STATUS: {
    all: 'Todos',
    open: 'Abierto',
    closed: 'Cerrado',
    muted: 'Silenciado',
  },
  TABLE: {
    STATUS: 'Estado',
  },
  SEARCH_PLACEHOLDER: 'Buscar vulnerabilidades...',
  EMPTY_STATE: 'No se encontraron vulnerabilidades',
  DRAWER: {
    SUMMARY: 'Resumen',
    SEVERITY: 'Severidad',
    CVSS: 'CVSS',
    HOSTS: 'Hosts',
    HOST: 'Host',
    PORT: 'Puerto',
    DESCRIPTION: 'Descripción',
    REMEDIATION: 'Remediación',
    AFFECTED_ASSETS: 'Hosts Afectados',
  },
  ITEM: {
    NA: 'N/A',
    HOSTS: 'hosts',
    MORE: 'más',
  },
  MONITORING: {
    LABEL: 'Resumen',
    VULNERABILITIES: 'vulnerabilidades',
    VULNERABILITY: 'vulnerabilidad',
    AFFECTED_HOSTS: 'hosts afectados',
    AFFECTED_HOST: 'host afectado',
    PORTS: 'puertos',
    PORT: 'puerto',
  },
  MUTE: {
    MUTE_BUTTON: 'Silenciar finding',
    UNMUTE_BUTTON: 'Reactivar finding',
    DIALOG_TITLE: 'Motivo del silenciado',
    SELECTION_SUMMARY: (selected: number, total: number) => `${selected} de ${total} ocurrencias seleccionadas`,
    JUSTIFICATION_LABEL: 'Justificación',
    JUSTIFICATION_PLACEHOLDER:
      '¿Por qué se silencia este finding? p. ej. falso positivo de un análisis externo, ' +
      'riesgo aceptado hasta que se corrija el host',
    CANCEL: 'Cancelar',
    BANNER_TITLE: (muted: number, total: number) => `Silenciado · ${muted} de ${total} ocurrencias`,
    MUTED_BADGE: 'Silenciado',
    MUTED_BY: (name: string) => `Silenciado por ${name}`,
    BY_SCANNER: 'Silenciado por el escáner externo',
    NOTHING_SELECTED_TOOLTIP: 'Selecciona al menos una ocurrencia',
    DORMANT_NOTE: 'Este silenciado volverá a aplicarse si el finding aparece en un análisis futuro',
    MUTE_SUCCESS: 'Finding silenciado',
    UNMUTE_SUCCESS: 'Finding reactivado',
    MUTE_PARTIAL: (muted: number, requested: number) =>
      `Silenciadas ${muted} de ${requested} ocurrencias — el resto ya no estaban abiertas`,
    UNMUTE_PARTIAL: (unmuted: number, requested: number) =>
      `Reactivadas ${unmuted} de ${requested} ocurrencias — el resto ya no estaban silenciadas`,
    MUTE_ERROR: 'No se ha podido silenciar el finding',
    UNMUTE_ERROR: 'No se ha podido reactivar el finding',
  },
}

export const EASM_BREACHES = {
  TITLE: 'Brechas Conocidas',
  NO_BREACHES_FOUND: 'No se encontraron brechas',
  SEARCH_PLACEHOLDER: 'Buscar brechas...',
  COLUMNS: {
    SEVERITY: 'Severidad',
    NAME: 'Nombre',
    DOMAIN: 'Dominio',
    TYPE: 'Tipo',
    DATABASE: 'Base de Datos',
    IP_TRACKED: 'IP Rastreada',
    REVIEWED: 'Revisada',
    ACTIONS: 'Acciones',
  },
  MONITORING: {
    LABEL: 'Monitoring',
    BREACH_SINGULAR: 'brecha',
    BREACH_PLURAL: 'brechas',
    DOMAIN_SINGULAR: 'dominio',
    DOMAIN_PLURAL: 'dominios',
    CRITICAL_SINGULAR: 'crítico',
    CRITICAL_PLURAL: 'críticos',
    HIGH_SINGULAR: 'alto',
    HIGH_PLURAL: 'altos',
    REVIEWED_SINGULAR: 'revisada',
    REVIEWED_PLURAL: 'revisadas',
  },
  REVIEW: {
    REVIEW_BUTTON: 'Revisar',
    MUTE_BUTTON: 'Marcar como revisada',
    DIALOG_TITLE: 'Marcar como revisada',
    JUSTIFICATION_LABEL: 'Justificación (opcional)',
    JUSTIFICATION_PLACEHOLDER: 'p. ej. contraseña cambiada, usuario avisado',
    CANCEL: 'Cancelar',
    MUTE_SUCCESS: 'Brecha marcada como revisada',
    MUTE_PARTIAL: (reviewed: number, requested: number) =>
      `${reviewed} de ${requested} brechas marcadas como revisadas`,
    MUTE_ERROR: 'No se pudo marcar la brecha como revisada',
    REVIEWED: 'Revisada',
    NOT_REVIEWED: 'Sin revisar',
    REVIEWED_BY: (name: string) => `Revisada por ${name}`,
  },
  REVIEW_FILTER: {
    ALL: 'Todas',
    PENDING: 'Sin revisar',
    REVIEWED: 'Revisadas',
  },
  EXPORT: {
    BUTTON: 'Exportar CSV',
    EMPTY: 'No hay brechas para exportar.',
    REVIEWED_REASON: 'Justificación de la revisión',
    REVIEWED_BY: 'Revisada por',
    REVIEWED_WHEN: 'Revisada el',
  },
  TYPES_INFO: {
    [BREACHES_TYPES.PASSWORD]: 'Contraseña encontrada en texto plano.',
    [BREACHES_TYPES.HASHED]: 'Contraseña encontrada, pero hasheada.',
    [BREACHES_TYPES.NOT_AVAILABLE]: 'No se encontró contraseña, pero se expuso correo u otros datos.',
  },
  IP_TRACKED_INFO: 'Dirección IP del usuario involucrada en la brecha (por ejemplo, inicio de sesión o solicitud)',
  BREACH_CARD: {
    DOMAIN: 'Dominio',
    NAME: 'Nombre',
    TYPE: 'Tipo',
    SEVERITY: 'Severidad',
    DATABASE: 'Base de Datos',
    IP_TRACKED: 'IP Rastreada',
    IP_TRACKED_YES: 'Sí',
    IP_TRACKED_NO: 'No',
    TYPES: {
      [BREACHES_TYPES.PASSWORD]: 'Contraseña',
      [BREACHES_TYPES.HASHED]: 'Hasheada',
      [BREACHES_TYPES.NOT_AVAILABLE]: 'Desconocido',
    },
    SEVERITIES: {
      critical: 'Crítico',
      high: 'Alto',
      medium: 'Medio',
      low: 'Bajo',
      unknown: 'Desconocido',
    },
  },
}
